<div class="os-history">
  <header class="os-history__header">
    <div class="os-history__icon" aria-hidden="true">
      <i-tabler name="history"></i-tabler>
    </div>
    <div>
      <h2>Historial de la OS</h2>
      <p>Recálculos de monto y pasajeros</p>
      <p *ngIf="data.lastRecalculatedAt">
        Último recálculo: {{ data.lastRecalculatedAt | date: 'dd/MM/yyyy HH:mm' }}<ng-container *ngIf="data.autoAdjusted"> · automático</ng-container>
      </p>
    </div>
    <button type="button" class="os-history__close" (click)="close()">Cerrar</button>
  </header>

  <div class="os-history__body">
    <p class="os-history__state" *ngIf="loading">Cargando historial...</p>
    <p class="os-history__state os-history__state--error" *ngIf="error">{{ error }}</p>
    <p class="os-history__state" *ngIf="!loading && !error && !items.length">
      Todavía no hay recálculos. Aparecen cuando el monto o los pasajeros de la OS cambian.
    </p>

    <article class="os-history__card" *ngFor="let item of items">
      <div class="os-history__card-head">
        <div class="os-history__tags">
          <span class="os-history__badge">{{ triggerLabel(item.trigger) }}</span>
          <span class="os-history__source">{{ sourceLabel(item.source) }}</span>
        </div>
        <time>{{ item.changedAt | date: 'dd/MM/yyyy HH:mm' }}</time>
      </div>

      <div class="os-history__delta">
        <span>Total</span>
        <strong [class.is-down]="wentDown(item.previousTotal, item.newTotal)" [class.is-up]="wentUp(item.previousTotal, item.newTotal)">
          {{ item.previousTotal | number: '1.2-2' }}
          <em>→</em>
          {{ item.newTotal | number: '1.2-2' }}
        </strong>
      </div>

      <div class="os-history__delta" *ngFor="let line of lineAmounts(item)">
        <span>Monto</span>
        <strong [class.is-down]="wentDown(line.previousAmount, line.newAmount)" [class.is-up]="wentUp(line.previousAmount, line.newAmount)">
          {{ line.previousAmount | number: '1.2-2' }}
          <em>→</em>
          {{ line.newAmount | number: '1.2-2' }}
        </strong>
      </div>

      <div class="os-history__delta" *ngFor="let line of paxChanges(item)">
        <span>Pasajeros</span>
        <strong [class.is-down]="wentDown(line.previousPax, line.newPax)" [class.is-up]="wentUp(line.previousPax, line.newPax)">
          {{ line.previousPax ?? '—' }}
          <em>→</em>
          {{ line.newPax ?? '—' }}
        </strong>
      </div>
    </article>
  </div>
</div>
